import { ProcessStep } from '../types';

export const processSteps: ProcessStep[] = [
  {
    title: 'Consultation',
    description: 'We meet to discuss your project goals, budget, and timeline. This allows us to understand your vision and needs.',
  },
  {
    title: 'Design & Planning',
    description: 'We create detailed plans and provide a comprehensive quote outlining all aspects of your project.',
  },
  {
    title: 'Construction',
    description: 'Our skilled team brings your project to life with quality craftsmanship and attention to detail.',
  },
  {
    title: 'Final Walkthrough',
    description: 'We review the completed project with you to ensure everything meets our high standards and your expectations.',
  },
];

// Note: Icons are JSX elements that need to be rendered in the component
export const additionalServicesData = [
  {
    title: 'Interior Design Collaboration',
    description: 'We work with interior designers or can recommend trusted professionals to enhance your project.',
  },
  {
    title: 'Project Management',
    description: 'Full-service project management ensuring your project stays on schedule and within budget.',
  },
  {
    title: 'Permit Handling',
    description: 'We navigate the permit process for you, ensuring all work is up to code and legally compliant.',
  },
]; 